// import React, { useState } from "react";
// import { motion } from "framer-motion";

// const TermsConditions = () => {
//   const [activeTerm, setActiveTerm] = useState(null);

//   const terms = [
//     {
//       number: "1",
//       title: "Educational Purpose Only",
//       icon: "🎓",
//       content: "All content provided on this platform is for educational and spiritual awareness. It should not be considered legal advice, medical advice, professional counseling, or a substitute for traditional guidance from authorized priests or gurus.",
//       highlights: [
//         "Not legal advice",
//         "Not medical advice", 
//         "Not professional counseling",
//         "Not a substitute for traditional guidance"
//       ]
//     },
//     {
//       number: "2",
//       title: "Copyright Disclaimer",
//       icon: "©️",
//       content: "Some scriptural references may be from texts in the public domain. Any copyrighted material (if included) is used under 'fair use' for educational and non-commercial purposes. If any copyrighted content is unintentionally used, please contact us for removal.",
//       highlights: [
//         "Public domain scriptures",
//         "Fair use for education",
//         "Non-commercial purpose",
//         "Contact for removal requests"
//       ]
//     },
//     {
//       number: "3", 
//       title: "No Liability",
//       icon: "🛡️",
//       content: "The platform creators shall not be responsible for incorrect interpretation, misuse of information, rituals performed without supervision, or any physical, emotional, or financial consequences. Users act at their own discretion.",
//       highlights: [
//         "No responsibility for interpretations",
//         "No liability for misuse",
//         "Rituals at user's risk", 
//         "Users act at own discretion"
//       ]
//     },
//     {
//       number: "4",
//       title: "Religious Sensitivity",
//       icon: "🙏",
//       content: "We respect every religious belief and interpretation. No content is intended to hurt sentiments or promote superiority of any ideology. If you find any issue, kindly report it for review.",
//       highlights: [
//         "Respect all beliefs",
//         "No intention to hurt sentiments",
//         "No ideological promotion",
//         "Report issues for review"
//       ]
//     },
//     {
//       number: "5",
//       title: "External Links & References",
//       icon: "🔗",
//       content: "Links or references (if used) are for information only. We are not responsible for the accuracy or content of external sources.",
//       highlights: [
//         "Informational links only",
//         "No responsibility for external content",
//         "References for guidance",
//         "Verify external sources"
//       ]
//     },
//     {
//       number: "6",
//       title: "Accountability", 
//       icon: "⚖️",
//       content: "Users should use the platform responsibly. Misuse for spreading misinformation, hate speech, or personal attacks is strictly prohibited.",
//       highlights: [
//         "Responsible usage required",
//         "No misinformation",
//         "No hate speech",
//         "No personal attacks"
//       ]
//     },
//     {
//       number: "7",
//       title: "Changes to Terms",
//       icon: "🔄", 
//       content: "These terms may be updated anytime without prior notice. Continued use of the platform means you accept the current terms.",
//       highlights: [
//         "Terms may update anytime",
//         "No prior notice required", 
//         "Continued use implies acceptance",
//         "Check terms regularly"
//       ]
//     },
//     {
//       number: "8",
//       title: "Contact/Feedback",
//       icon: "📧",
//       content: "If you believe any content violates copyright, legal norms, or religious values, you can write to us. We will review and act promptly.",
//       highlights: [
//         "Report copyright issues",
//         "Report legal concerns", 
//         "Report religious sensitivity",
//         "Prompt review and action"
//       ]
//     }
//   ];

//   const getGradient = (index) => {
//     const gradients = [
//       "from-blue-500 to-cyan-500",
//       "from-green-500 to-emerald-500", 
//       "from-purple-500 to-pink-500",
//       "from-orange-500 to-red-500",
//       "from-teal-500 to-blue-500",
//       "from-yellow-500 to-orange-500",
//       "from-indigo-500 to-purple-500",
//       "from-pink-500 to-rose-500"
//     ];
//     return gradients[index % gradients.length];
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 py-8 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-12"
//         >
//           <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl mb-6 shadow-2xl">
//             <span className="text-2xl">⚖️</span>
//           </div>
//           <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-4">
//             Terms & Conditions
//           </h1>
//           <p className="text-xl text-gray-300 max-w-2xl mx-auto">
//             Legal & Safe Version - Please read these terms carefully before using our platform
//           </p>
//         </motion.div>

//         {/* Terms Grid */}
//         <div className="grid md:grid-cols-2 gap-6 mb-12">
//           {terms.map((term, index) => (
//             <motion.div
//               key={term.number}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: index * 0.1 }}
//               className={`bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border-2 transition-all duration-300 cursor-pointer ${
//                 activeTerm === index 
//                   ? 'border-blue-500 shadow-2xl shadow-blue-500/20' 
//                   : 'border-gray-700 hover:border-blue-400/50'
//               }`}
//               onClick={() => setActiveTerm(activeTerm === index ? null : index)}
//             >
//               {/* Header */}
//               <div className="flex items-start gap-4 mb-4">
//                 <div className={`flex-shrink-0 w-12 h-12 bg-gradient-to-br ${getGradient(index)} rounded-xl flex items-center justify-center text-white font-bold text-lg`}>
//                   {term.number}
//                 </div>
//                 <div className="flex-1">
//                   <div className="flex items-center gap-3 mb-2">
//                     <span className="text-xl">{term.icon}</span>
//                     <h3 className="text-xl font-semibold text-white">{term.title}</h3>
//                   </div>
//                   <p className="text-gray-300 text-sm leading-relaxed">
//                     {term.content}
//                   </p>
//                 </div>
//               </div>

//               {/* Highlights */}
//               {activeTerm === index && (
//                 <motion.div
//                   initial={{ opacity: 0, height: 0 }}
//                   animate={{ opacity: 1, height: "auto" }}
//                   transition={{ duration: 0.3 }}
//                   className="mt-4 pt-4 border-t border-gray-700"
//                 >
//                   <h4 className="text-sm font-semibold text-gray-400 mb-3">Key Points:</h4>
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
//                     {term.highlights.map((highlight, idx) => (
//                       <div key={idx} className="flex items-center gap-2">
//                         <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
//                         <span className="text-sm text-gray-300">{highlight}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </motion.div>
//               )}

//               {/* Expand Indicator */}
//               <div className="flex justify-center mt-4">
//                 <div className="w-8 h-8 rounded-full bg-gray-700/50 flex items-center justify-center">
//                   <span className="text-gray-400 text-sm">
//                     {activeTerm === index ? "−" : "+"}
//                   </span>
//                 </div>
//               </div>
//             </motion.div>
//           ))}
//         </div>

//         {/* Important Notice */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, delay: 0.8 }}
//           className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl p-8 border border-blue-500/30"
//         >
//           <div className="text-center">
//             <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500/30 rounded-2xl mb-4">
//               <span className="text-2xl">💡</span>
//             </div>
//             <h3 className="text-2xl font-bold text-white mb-4">Important Notice</h3>
//             <p className="text-gray-300 text-lg leading-relaxed max-w-3xl mx-auto">
//               By using Dharma Guide, you acknowledge and agree to these terms and conditions. 
//               Our mission is purely educational - to make authentic scriptural wisdom accessible 
//               while respecting all traditions and interpretations within Sanatan Dharma.
//             </p>
//             <div className="mt-6 flex flex-wrap gap-4 justify-center">
//               <span className="px-4 py-2 bg-blue-500/30 text-blue-300 rounded-full text-sm border border-blue-500/50">
//                 Educational Purpose Only
//               </span>
//               <span className="px-4 py-2 bg-green-500/30 text-green-300 rounded-full text-sm border border-green-500/50">
//                 Respect All Traditions
//               </span>
//               <span className="px-4 py-2 bg-purple-500/30 text-purple-300 rounded-full text-sm border border-purple-500/50">
//                 No Commercial Activity
//               </span>
//             </div>
//           </div>
//         </motion.div>

//         {/* Footer */}
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.6, delay: 1 }}
//           className="text-center mt-8 pt-6 border-t border-gray-700"
//         >
//           <p className="text-gray-400 text-sm">
//             Dharma Guide • Spiritual Education Platform
//           </p>
//           <p className="text-gray-500 text-xs mt-2">
//             Last updated: {new Date().toLocaleDateString('en-US', { 
//               year: 'numeric', 
//               month: 'long', 
//               day: 'numeric' 
//             })}
//           </p>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default TermsConditions;









import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const TermsConditions = () => {
  const [activeTerm, setActiveTerm] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const terms = [
    {
      number: "01",
      title: "Educational Purpose Only",
      icon: "🎓",
      accent: "#61dafb",
      content:
        "All content provided on DharmaAnswers is for educational and spiritual awareness only. It should not be considered legal advice, medical advice, professional counseling, or a substitute for traditional guidance from authorized priests or qualified acharyas.",
      highlights: [
        "Not legal advice",
        "Not medical advice",
        "Not professional counseling",
        "Not a substitute for traditional guidance",
      ],
    },
    {
      number: "02",
      title: "Original Platform & IP",
      icon: "🛡️",
      accent: "#fbbf24",
      content:
        "DharmaAnswers is an original concept independently created and developed by Krishna Kumar, starting November 2025, first publicly deployed January 2026. The platform's design, architecture, feature set, prompt engineering approach, and core concept are proprietary intellectual property. Unauthorized reproduction, cloning, or commercial use is strictly prohibited.",
      highlights: [
        "Original concept by Krishna Kumar",
        "Development started: November 2025",
        "First deployed: January 2026",
        "Proprietary design & architecture",
      ],
    },
    {
      number: "03",
      title: "Copyright Disclaimer",
      icon: "©️",
      accent: "#a78bfa",
      content:
        "Scriptural references used on this platform are primarily from texts in the public domain. Any copyrighted material, if included, is used under 'fair use' for educational and non-commercial purposes only. If any copyrighted content is unintentionally used, please contact us for prompt removal.",
      highlights: [
        "Public domain scriptures",
        "Fair use for education only",
        "Non-commercial purpose",
        "Contact for removal requests",
      ],
    },
    {
      number: "04",
      title: "No Liability",
      icon: "⚖️",
      accent: "#34d399",
      content:
        "The platform creators and developers shall not be responsible for incorrect interpretation, misuse of information, rituals performed without supervision, or any physical, emotional, or financial consequences arising from use of this platform. Users act entirely at their own discretion and risk.",
      highlights: [
        "No responsibility for interpretations",
        "No liability for misuse",
        "Rituals at user's own risk",
        "Users act at own discretion",
      ],
    },
    {
      number: "05",
      title: "Religious Sensitivity",
      icon: "🙏",
      accent: "#f87171",
      content:
        "We deeply respect every religious belief, sampradaya, and interpretation within Sanatan Dharma and beyond. No content is intended to hurt religious sentiments or promote the superiority of any ideology. If you find any issue, please report it for immediate review.",
      highlights: [
        "Respect for all traditions",
        "No intention to hurt sentiments",
        "No ideological promotion",
        "Report issues for review",
      ],
    },
    {
      number: "06",
      title: "AI-Generated Content",
      icon: "🤖",
      accent: "#818cf8",
      content:
        "Answers on this platform are AI-assisted and based on scriptural references. While every effort is made to ensure accuracy and authenticity, AI responses may carry limitations. Users are encouraged to verify important matters with qualified scholars or acharyas.",
      highlights: [
        "AI-assisted answers",
        "Scriptural reference based",
        "May have limitations",
        "Verify with qualified scholars",
      ],
    },
    {
      number: "07",
      title: "Accountability",
      icon: "🔐",
      accent: "#06b6d4",
      content:
        "Users are expected to use DharmaAnswers responsibly and with spiritual sincerity. Misuse for spreading misinformation, hate speech, personal attacks, or any activity contrary to the platform's educational and spiritual purpose is strictly prohibited.",
      highlights: [
        "Responsible usage required",
        "No misinformation spreading",
        "No hate speech",
        "No personal attacks",
      ],
    },
    {
      number: "08",
      title: "External Links & References",
      icon: "🔗",
      accent: "#fb7185",
      content:
        "Any external links or references used are for informational purposes only. DharmaAnswers is not responsible for the accuracy, completeness, or content of external sources. Users should independently verify any external information.",
      highlights: [
        "Informational links only",
        "No responsibility for external content",
        "Verify external sources independently",
        "References for guidance only",
      ],
    },
    {
      number: "09",
      title: "Changes to Terms",
      icon: "🔄",
      accent: "#a3e635",
      content:
        "These terms and conditions may be updated at any time without prior notice as the platform evolves. Continued use of DharmaAnswers after any updates constitutes your acceptance of the revised terms. Users are encouraged to review this page periodically.",
      highlights: [
        "Terms may update anytime",
        "No prior notice required",
        "Continued use implies acceptance",
        "Review periodically",
      ],
    },
    {
      number: "10",
      title: "Contact & Feedback",
      icon: "📧",
      accent: "#f59e0b",
      content:
        "If you believe any content violates copyright, legal norms, religious values, or the platform's stated purpose, please write to us via the Contact section. We will review all concerns promptly and take appropriate action.",
      highlights: [
        "Report copyright issues",
        "Report legal concerns",
        "Report religious sensitivity issues",
        "Prompt review and action",
      ],
    },
  ];

  const badges = [
    { label: "Educational Purpose Only", color: "#61dafb", bg: "rgba(97,218,251,0.1)" },
    { label: "Respect All Traditions", color: "#34d399", bg: "rgba(52,211,153,0.1)" },
    { label: "No Commercial Activity", color: "#a78bfa", bg: "rgba(167,139,250,0.1)" },
    { label: "Original Concept © 2025", color: "#fbbf24", bg: "rgba(251,191,36,0.1)" },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #04040f 0%, #080818 50%, #0a0612 100%)",
        fontFamily: "'Crimson Pro', Georgia, serif",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background decoration */}
      <div style={{
        position: "fixed", top: "-200px", left: "50%", transform: "translateX(-50%)",
        width: "800px", height: "400px", borderRadius: "50%",
        background: "radial-gradient(ellipse, rgba(97,218,251,0.03) 0%, transparent 70%)",
        pointerEvents: "none", zIndex: 0,
      }} />

      {/* Back to top */}
      <AnimatePresence>
        {scrolled && (
          <motion.button
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={{
              position: "fixed", bottom: "32px", right: "32px", zIndex: 100,
              width: "48px", height: "48px", borderRadius: "50%",
              background: "rgba(97,218,251,0.1)",
              border: "1px solid rgba(97,218,251,0.3)",
              color: "#61dafb", fontSize: "20px", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              backdropFilter: "blur(10px)",
            }}
          >↑</motion.button>
        )}
      </AnimatePresence>

      <div style={{ position: "relative", zIndex: 1, maxWidth: "1100px", margin: "0 auto", padding: "clamp(32px, 7vw, 60px) clamp(14px, 4vw, 24px)" }}>

        {/* ── HEADER ── */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ textAlign: "center", marginBottom: "clamp(40px, 8vw, 72px)" }}
        >
          <motion.div
            animate={{ y: [0, -6, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              width: "clamp(72px, 16vw, 90px)", height: "clamp(72px, 16vw, 90px)", borderRadius: "24px",
              background: "linear-gradient(135deg, rgba(97,218,251,0.15), rgba(167,139,250,0.15))",
              border: "1px solid rgba(97,218,251,0.25)",
              fontSize: "clamp(32px, 7vw, 40px)", marginBottom: "clamp(20px, 5vw, 28px)",
              boxShadow: "0 0 40px rgba(97,218,251,0.15)",
            }}
          >⚖️</motion.div>

          <h1 style={{
            fontSize: "clamp(2.2rem, 5vw, 4rem)",
            fontWeight: "700",
            background: "linear-gradient(135deg, #61dafb 0%, #a78bfa 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            marginBottom: "16px",
            fontFamily: "'Cinzel', Georgia, serif",
            letterSpacing: "-0.5px",
          }}>
            Terms & Conditions
          </h1>

          <p style={{ color: "#64748b", marginBottom: "28px", fontFamily: "'Crimson Pro', Georgia, serif", fontSize: "clamp(1rem, 3.4vw, 1.15rem)", lineHeight: 1.7 }}>
            Please read these terms carefully before using DharmaAnswers
          </p>

          {/* IP + date badge */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "8px",
              padding: "10px 18px",
              background: "rgba(251,191,36,0.08)",
              border: "1px solid rgba(251,191,36,0.2)",
              borderRadius: "50px",
              maxWidth: "min(100%, 760px)",
              margin: "0 auto",
            }}
          >
            <span style={{ fontSize: "16px" }}>🛡️</span>
            <span style={{ color: "#fbbf24", fontSize: "13px", fontFamily: "monospace", lineHeight: 1.6, wordBreak: "break-word", textAlign: "center" }}>
              © 2025–2026 DharmaAnswers · Original concept by Krishna Kumar · All rights reserved
            </span>
          </motion.div>
        </motion.div>

        {/* ── TERMS GRID ── */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 320px), 1fr))",
          gap: "16px",
          marginBottom: "60px",
        }}>
          {terms.map((term, index) => (
            <motion.div
              key={term.number}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.06 * index }}
              onClick={() => setActiveTerm(activeTerm === index ? null : index)}
              style={{
                background: activeTerm === index
                  ? `rgba(255,255,255,0.04)`
                  : "rgba(255,255,255,0.02)",
                border: `1px solid ${activeTerm === index ? term.accent + "50" : "rgba(255,255,255,0.07)"}`,
                borderRadius: "20px",
                padding: "clamp(18px, 4vw, 24px) clamp(16px, 4vw, 28px)",
                cursor: "pointer",
                transition: "all 0.3s ease",
                // Special: IP term gets full width
                gridColumn: index === 1 ? "1 / -1" : "auto",
              }}
            >
              {/* Term header */}
              <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
                {/* Number badge */}
                <div style={{
                  width: "44px", height: "44px", borderRadius: "12px", flexShrink: 0,
                  background: `${term.accent}15`,
                  border: `1px solid ${term.accent}30`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "monospace", fontSize: "12px", fontWeight: "700",
                  color: term.accent,
                }}>
                  {term.number}
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <span style={{ fontSize: "18px" }}>{term.icon}</span>
                      <h3 style={{
                        color: activeTerm === index ? term.accent : "#cbd5e1",
                        fontSize: "1rem", fontWeight: "600",
                        fontFamily: "'Cinzel', Georgia, serif",
                        transition: "color 0.3s",
                      }}>
                        {term.title}
                      </h3>
                    </div>
                    <span style={{
                      color: "#475569", fontSize: "18px",
                      transition: "transform 0.3s",
                      transform: activeTerm === index ? "rotate(180deg)" : "none",
                      display: "inline-block",
                    }}>⌄</span>
                  </div>

                  <p style={{
                    color: "#94a3b8", fontSize: "0.92rem", lineHeight: 1.8,
                    fontFamily: "'Crimson Pro', Georgia, serif",
                  }}>
                    {term.content}
                  </p>

                  {/* Expanded highlights */}
                  <AnimatePresence>
                    {activeTerm === index && (
                      <motion.div
                        initial={{ opacity: 0, height: 0, marginTop: 0 }}
                        animate={{ opacity: 1, height: "auto", marginTop: "16px" }}
                        exit={{ opacity: 0, height: 0, marginTop: 0 }}
                        style={{ overflow: "hidden" }}
                      >
                        <div style={{
                          borderTop: `1px solid ${term.accent}20`,
                          paddingTop: "16px",
                        }}>
                          <p style={{ color: "#475569", fontSize: "11px", letterSpacing: "2px", textTransform: "uppercase", fontFamily: "monospace", marginBottom: "12px" }}>
                            Key Points
                          </p>
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 180px), 1fr))", gap: "8px" }}>
                            {term.highlights.map((h, i) => (
                              <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <div style={{ width: "5px", height: "5px", borderRadius: "50%", background: term.accent, flexShrink: 0 }} />
                                <span style={{ color: "#94a3b8", fontSize: "13px", fontFamily: "'Crimson Pro', Georgia, serif" }}>{h}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* ── IMPORTANT NOTICE ── */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          style={{
            background: "linear-gradient(135deg, rgba(97,218,251,0.06), rgba(167,139,250,0.06))",
            border: "1px solid rgba(97,218,251,0.2)",
            borderRadius: "24px",
            padding: "clamp(24px, 6vw, 48px) clamp(18px, 5vw, 40px)",
            marginBottom: "48px",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Top line */}
          <div style={{
            position: "absolute", top: 0, left: 0, right: 0, height: "2px",
            background: "linear-gradient(90deg, transparent, #61dafb, #a78bfa, transparent)",
          }} />

          <div style={{ fontSize: "32px", marginBottom: "16px" }}>💡</div>

          <h3 style={{
            color: "#e2e8f0", fontSize: "1.5rem", fontWeight: "700",
            fontFamily: "'Cinzel', Georgia, serif", marginBottom: "16px",
          }}>
            Important Notice
          </h3>

          <p style={{
            color: "#94a3b8", lineHeight: 1.9, fontSize: "1.05rem",
            maxWidth: "700px", margin: "0 auto 28px",
            fontFamily: "'Crimson Pro', Georgia, serif",
          }}>
            By using <span style={{ color: "#61dafb", fontWeight: "600" }}>DharmaAnswers</span>, you acknowledge and agree to these terms. Our mission is purely educational — to make authentic scriptural wisdom accessible while respecting all traditions and interpretations within Sanatan Dharma.
          </p>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
            {badges.map((b) => (
              <span
                key={b.label}
                style={{
                  padding: "8px 18px",
                  background: b.bg,
                  color: b.color,
                  border: `1px solid ${b.color}40`,
                  borderRadius: "50px",
                  fontSize: "13px",
                  fontFamily: "monospace",
                }}
              >
                {b.label}
              </span>
            ))}
          </div>
        </motion.div>

        {/* ── COPYRIGHT FOOTER ── */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          style={{
            textAlign: "center",
            paddingTop: "24px",
            borderTop: "1px solid rgba(255,255,255,0.05)",
          }}
        >
          <p style={{ color: "#334155", fontSize: "13px", fontFamily: "monospace", marginBottom: "6px", lineHeight: 1.8, wordBreak: "break-word" }}>
            © 2025–2026 DharmaAnswers &nbsp;·&nbsp;
            Original concept & development by <span style={{ color: "#61dafb" }}>Krishna Kumar</span> &nbsp;·&nbsp;
            All rights reserved
          </p>
          <p style={{ color: "#1e293b", fontSize: "12px", fontFamily: "monospace", lineHeight: 1.8, wordBreak: "break-word" }}>
            Development started: November 2025 &nbsp;·&nbsp; First deployed: January 2026 &nbsp;·&nbsp; v1.3.0
          </p>
        </motion.div>

      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Crimson+Pro:ital,wght@0,400;0,600;1,400&display=swap');
      `}</style>
    </div>
  );
};

export default TermsConditions;
